import Auth from '@/api/auth.api.js';
import { ROLE_USER , ROLE_ADMIN } from "@/constants/organization";

/*eslint-disable */
export const auth = ({ commit }, data) => {
  commit('LOGIN_FAILED', false);
  return Auth.login(data.data)
    .then(response => {
      if (response && response.success && response.data.token) {
        localStorage.setItem("token", response.data.token)
        const token = response.data.token
        const start = Number(token.indexOf('.')) + 1
        const end = token.lastIndexOf('.')
        const json = token.slice(start, end)
        const user = JSON.parse(atob(json))
        commit("SET_TOKEN", response.data.token)
        if(data.sefl.$router.app._route.path !== '/' && (user.role === ROLE_USER || (user.role === ROLE_ADMIN && !user.is_superuser)) ) {
          data.sefl.$router.push('/');
        }
        if (user.role === ROLE_ADMIN && user.is_superuser) {
          data.sefl.$router.push('/admin/organizations');
        }
      }
      return response;
    })
    .catch(e => {
      commit('LOGIN_FAILED', true);
    })
}

export const register = ({ commit }, data) => {
  return Auth.register(data.data)
    .then(response => {
      if (response && response.success) {
        data.sefl.$router.push({
          name: 'login',
          query: {
            email: response.data.email,
          }
        });
      }
    })
}

export const getAuthUser = ({ commit }, ) => {
  return Auth.getAuthUser()
    .then(response => {
      commit("SET_AUTH_USER", response.data);
      return response.data;
    })
}

export const forgotPassword = ({ commit }, email) => {
  return Auth.forgotPassword(email).then((response) => {
    commit("SET_EMAIL_RESET", response.data.email);
    return response;
  });
};

export const resetPassword = ({ commit }, data) => {
  return Auth.resetPassword(data).then((response) => {
    return response;
  });
};

export const getListKeyAuthUser = ({ commit }, ) => {
  return Auth.getListKeyAuthUser()
    .then(response => {
      commit("SET_LIST_KEY_AUTH_USER", response.data.key_list);
      return response.data.key_list;
    })
}

export const logOut = ({ commit }) => {
  return Auth.logout().then(response => {
    commit('LOG_OUT');
  })
}

export const setTimerCountDown = ({ commit }, timer) => {
  commit("SET_TIMER_COUNTDOWN", timer);
};

export const changePasswordUser = ({ commit }, data) => {
  return Auth.changePasswordUser(data).then((response) => {
    return response;
  });
};
/*eslint-enable */
